/* Octa Pearl collection filters: instant filtering on desktop, bottom sheet with "Show N results" on phones.
   Swaps #ProductGridContainer and this section using Shopify's Section Rendering API; falls back to a normal page load. */
(function () {
  'use strict';
  if (window.lgFilters) return;
  window.lgFilters = true;
  var root, sid, gridSid, ctrl, pctrl, openId = null, lastUrl = location.href;

  function gridSection() {
    var c = document.getElementById('ProductGridContainer');
    var s = c && c.closest('[id^="shopify-section-"]');
    return s ? s.id.replace('shopify-section-', '') : null;
  }
  function urlFrom(form) {
    var p = new URLSearchParams();
    new FormData(form).forEach(function (v, k) {
      v = String(v).trim();
      if (!v) return;
      if (/price\.(gte|lte)$/.test(k)) { v = v.replace(/[^0-9.]/g, ''); if (!v) return; }
      p.append(k, v);
    });
    var qs = p.toString();
    return root.dataset.base + (qs ? '?' + qs : '');
  }
  function withParam(url, k, v) { return url + (url.indexOf('?') > -1 ? '&' : '?') + k + '=' + encodeURIComponent(v); }
  function closeAll(except) {
    root.querySelectorAll('.lgcf__desk [data-lgf-group].is-open').forEach(function (g) {
      if (g === except) return;
      g.classList.remove('is-open');
      var b = g.querySelector('[data-lgf-toggle]'); if (b) b.setAttribute('aria-expanded', 'false');
    });
    if (!except) openId = null;
  }
  function markWishlist() {
    var list = []; try { list = JSON.parse(localStorage.getItem('wishlist') || '[]') || []; } catch (e) {}
    document.querySelectorAll('#ProductGridContainer .wishlist-custom-action').forEach(function (a) {
      if (list.indexOf(a.getAttribute('data-handle')) > -1) { a.classList.add('active-wishlist'); a.classList.remove('wishlist-custom-action'); }
    });
  }
  function setTop() {
    var h = document.querySelector('.lgh-section');
    var top = h ? Math.max(0, h.getBoundingClientRect().bottom) : 0;
    document.documentElement.style.setProperty('--lgf-top', top + 'px');
  }

  function apply(url, push) {
    if (push !== false) { try { history.pushState({ lgf: 1 }, '', url); } catch (e) {} }
    lastUrl = location.href;
    if (!gridSid) { location.href = url; return; }
    if (ctrl) ctrl.abort();
    ctrl = window.AbortController ? new AbortController() : null;
    root.classList.add('is-loading');
    var grid = document.getElementById('ProductGridContainer');
    if (grid) grid.classList.add('lgcf-dim');
    fetch(withParam(url, 'sections', gridSid + ',' + sid), ctrl ? { signal: ctrl.signal } : {})
      .then(function (r) { if (!r.ok) throw new Error('bad'); return r.json(); })
      .then(function (j) {
        var gd = new DOMParser().parseFromString(j[gridSid] || '', 'text/html');
        var ng = gd.getElementById('ProductGridContainer');
        var cur = document.getElementById('ProductGridContainer');
        if (!ng || !cur) throw new Error('missing');
        cur.innerHTML = ng.innerHTML;
        cur.classList.remove('lgcf-dim');
        var sd = new DOMParser().parseFromString(j[sid] || '', 'text/html');
        var nr = sd.querySelector('[data-lgf]');
        if (nr) {
          var keepOpen = openId;
          root.replaceWith(document.importNode(nr, true));
          bind();
          if (keepOpen) {
            var b = root.querySelector('[aria-controls="' + keepOpen + '"]');
            if (b) { b.closest('[data-lgf-group]').classList.add('is-open'); b.setAttribute('aria-expanded', 'true'); openId = keepOpen; }
          }
        }
        markWishlist();
        var bar = root.querySelector('[data-lgf-bar]');
        if (bar && !openId) {
          var y = bar.getBoundingClientRect().top + window.scrollY - (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--lgf-top')) || 0);
          if (window.scrollY > y + 10) window.scrollTo({ top: y, behavior: 'smooth' });
        }
        document.dispatchEvent(new CustomEvent('lgf:updated'));
      })
      .catch(function (e) { if (e && e.name === 'AbortError') return; location.href = url; })
      .finally(function () { if (root) root.classList.remove('is-loading'); });
  }
  var t;
  function applySoon(url) { clearTimeout(t); t = setTimeout(function () { apply(url); }, 250); }

  function preview(url) {
    var out = root.querySelector('[data-lgf-preview]'), btn = root.querySelector('[data-lgf-show]');
    if (!out) return;
    if (pctrl) pctrl.abort();
    pctrl = window.AbortController ? new AbortController() : null;
    btn.classList.add('is-busy');
    fetch(withParam(url, 'section_id', sid), pctrl ? { signal: pctrl.signal } : {})
      .then(function (r) { return r.text(); })
      .then(function (h) {
        var d = new DOMParser().parseFromString(h, 'text/html');
        var c = d.querySelector('[data-lgf-count]');
        if (c) { var n = c.textContent.trim(); out.textContent = n; btn.disabled = n === '0'; var w = root.querySelector('[data-lgf-word]'); if (w) w.textContent = n === '1' ? 'result' : 'results'; }
        /* refresh counts inside the sheet without losing what the shopper ticked */
        var fresh = d.querySelectorAll('[data-lgf-form="mob"] .lgcf__count');
        root.querySelectorAll('[data-lgf-form="mob"] .lgcf__count').forEach(function (el, i) { if (fresh[i]) el.textContent = fresh[i].textContent; });
      })
      .catch(function () {})
      .finally(function () { btn.classList.remove('is-busy'); });
  }

  function bind() {
    root = document.querySelector('[data-lgf]');
    if (!root) return;
    sid = root.dataset.sectionId;
    gridSid = gridSection();
    var desk = root.querySelector('[data-lgf-form="desk"]'), mob = root.querySelector('[data-lgf-form="mob"]');
    var sheet = root.querySelector('[data-lgf-sheet]');

    root.querySelectorAll('[data-lgf-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var g = btn.closest('[data-lgf-group]'), inSheet = !!btn.closest('[data-lgf-sheet]');
        var open = !g.classList.contains('is-open');
        if (!inSheet) { closeAll(g); openId = open ? btn.getAttribute('aria-controls') : null; }
        g.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
    function priceKeys(form) {
      form.querySelectorAll('[data-lgf-price]').forEach(function (i) {
        i.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); i.blur(); } });
      });
      form.querySelectorAll('[data-lgf-max]').forEach(function (b) {
        b.addEventListener('click', function () {
          var g = b.closest('[data-lgf-panel]'), ins = g.querySelectorAll('[data-lgf-price]');
          if (ins[0]) ins[0].value = ''; if (ins[1]) ins[1].value = b.dataset.lgfMax;
          form.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    }
    if (desk) {
      priceKeys(desk);
      desk.addEventListener('change', function () { applySoon(urlFrom(desk)); });
    }
    var sort = root.querySelector('[data-lgf-sort]');
    if (sort && desk) sort.addEventListener('change', function () { desk.querySelector('input[name="sort_by"]').value = sort.value; apply(urlFrom(desk)); });

    if (mob && sheet) {
      priceKeys(mob);
      mob.addEventListener('change', function () { preview(urlFrom(mob)); });
      root.querySelector('[data-lgf-open]').addEventListener('click', function () {
        sheet.showModal(); document.documentElement.classList.add('lgcf-lock');
      });
      sheet.addEventListener('close', function () { document.documentElement.classList.remove('lgcf-lock'); });
      sheet.addEventListener('click', function (e) { if (e.target === sheet) sheet.close(); });
      root.querySelector('[data-lgf-close]').addEventListener('click', function () { sheet.close(); });
      root.querySelector('[data-lgf-show]').addEventListener('click', function () { var u = urlFrom(mob); sheet.close(); apply(u); });
    }
    /* shape ribbon: one tap filters by that shape */
    root.querySelectorAll('[data-lgcf-shape]').forEach(function (b) {
      b.addEventListener('click', function () {
        var on = b.getAttribute('aria-pressed') !== 'true';
        [desk, mob].forEach(function (f) {
          if (!f) return;
          f.querySelectorAll('input[type="checkbox"]').forEach(function (i) {
            if (i.name === b.dataset.param && i.value === b.dataset.lgcfShape) i.checked = on;
          });
        });
        b.setAttribute('aria-pressed', on ? 'true' : 'false'); b.classList.toggle('is-on', on);
        openId = null; apply(urlFrom(desk || mob));
      });
    });
    /* price slider <-> min/max boxes */
    root.querySelectorAll('[data-lgcf-range]').forEach(function (r) {
      var panel = r.closest('[data-lgf-panel]'), form = r.closest('form');
      var rmin = r.querySelector('[data-lgcf-rmin]'), rmax = r.querySelector('[data-lgcf-rmax]'), fill = r.querySelector('[data-lgcf-fill]');
      var boxes = panel.querySelectorAll('[data-lgf-price]'), max = parseFloat(r.dataset.max) || 1;
      function paint() {
        var a = +rmin.value, b = +rmax.value;
        fill.style.left = (a / max * 100) + '%'; fill.style.right = (100 - b / max * 100) + '%';
      }
      function fromSlider(e) {
        var a = +rmin.value, b = +rmax.value;
        if (a > b - 50) { if (e && e.target === rmin) { rmin.value = b - 50; } else { rmax.value = a + 50; } }
        boxes[0].value = +rmin.value > 0 ? rmin.value : '';
        boxes[1].value = +rmax.value < max ? rmax.value : '';
        paint();
      }
      rmin.addEventListener('input', fromSlider); rmax.addEventListener('input', fromSlider);
      [rmin, rmax].forEach(function (x) { x.addEventListener('change', function (e) { e.stopPropagation(); form.dispatchEvent(new Event('change', { bubbles: true })); }); });
      boxes.forEach(function (bx) { bx.addEventListener('input', function () { rmin.value = boxes[0].value || 0; rmax.value = boxes[1].value || max; paint(); }); });
      paint();
    });
    root.querySelectorAll('[data-lgf-link]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        if (e.metaKey || e.ctrlKey) return;
        e.preventDefault(); if (sheet && sheet.open) sheet.close(); openId = null; apply(a.href);
      });
    });
  }

  document.addEventListener('click', function (e) {
    if (!root || !openId) return;
    if (!e.target.closest('.lgcf__desk [data-lgf-group]')) closeAll();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root && openId) {
      var b = root.querySelector('[aria-controls="' + openId + '"]'); closeAll(); if (b) b.focus();
    }
  });
  window.addEventListener('popstate', function () { if (root && location.href !== lastUrl) apply(location.href, false); });
  window.addEventListener('scroll', setTop, { passive: true });
  window.addEventListener('resize', setTop);
  function start() { bind(); setTop(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
